import React from "react";
import { Div } from "../../../styles/Common";
import { Input } from "../../../components/Input";
import { useMediaQuery } from "react-responsive";
import { theme } from "../../../styles/theme";

export const ItemsSubPanel = ({ itemsInfo, handleChangeItems, indx }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });

  return (
    <Div direction="column" gap="16px">
      {itemsInfo.map((item, index) => (
        <Input
          key={`${indx}-${index}`}
          id={`${item.name}`}
          label={`${item.name}`}
          placeholder={`${item.name}`}
          value={item.value || ""}
          onChange={(e) => handleChangeItems(e, index, indx)}
          disabled={isMobile}
        />
      ))}
    </Div>
  );
};
